export default __webpack_public_path__ + "static/media/photo--lg--kara10.b1a69cdf.jpg";